"use strict";

module.exports = function () {
    $(document).on("click", ".info-icon", function () {
        const $closestTooltipOpened = $(this).find(".bag-tooltip");

        if ($closestTooltipOpened.hasClass("d-none")) {
            $(".tooltip").addClass("d-none");
            $closestTooltipOpened.removeClass("d-none");
        } else {
            $closestTooltipOpened.addClass("d-none");
        }
    });
};
